module.exports = __webpack_public_path__ + "img/xlwb.37d5f29c.png";